import { render } from "./LinkObjectDialog.vue?vue&type=template&id=55719c1a&scoped=true"
import script from "./LinkObjectDialog.vue?vue&type=script&lang=js"
export * from "./LinkObjectDialog.vue?vue&type=script&lang=js"

import "./LinkObjectDialog.vue?vue&type=style&index=0&id=55719c1a&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55719c1a"]])

export default __exports__